export function focusInput (el: HTMLInputElement | HTMLTextAreaElement, preventScroll?: boolean) {
  el.focus({
    preventScroll
  });

  const value = el.value || '';
  el.value = '';
  el.value = value;
}
